import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AudiobookData, AudiobookState } from "./audiobook.type";

const initialState: AudiobookState = {
  audiobookData: {
    chapterName: "",
    linkAudio: "",
  },
  isPanelShow: false,
};

const audiobookSlice = createSlice({
  name: "@audiobook",
  initialState,
  reducers: {
    sendAudiobook(state, action: PayloadAction<AudiobookData>) {
      state.audiobookData = action.payload;
    },
    showAudiobookPanel(state) {
      state.isPanelShow = true;
    },
    clearAudiobook: () => initialState,
  },
});

export const { sendAudiobook, showAudiobookPanel, clearAudiobook } =
  audiobookSlice.actions;

export default audiobookSlice.reducer;
